import React from "react";
import AdminHeader from "components/Header/AdminHeader";
import AdminSidebar from "components/enterprise/AdminSidebar";
import { withRouter } from "react-router-dom";
import { Layout, Spin, Alert } from "antd";
import _notification from 'modules/notification';
const key = "updatable";

const { Content } = Layout;

let myThis = "";
// Sprint 2.6.3 (Enterprise Operations Console): now wraps content in antd's Layout alongside the new
// AdminSidebar. Replaces the previous fragile `calc(100vh - 145px)` magic-number height (themes.scss)
// with a flex-based full-height column, which no longer needs re-deriving now that the header is shorter.
class AdminLayout extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isPageLoaded: false,
            showBorderMargin: false
        };
    }
    componentDidMount() {
        //console.log("Admin layout");
    }

    render() {
        let isShowSpinner = this.state.isPageLoaded;
        let showAnalysisRunning = this.state.showAnalysisRunning;

        const currentYear = new Date().getFullYear();
        const previousYear = currentYear - 1;


        return (
            // Admin Dashboard Visual Refinement (round 2): `admin-shell-refined` is a new, dedicated
            // scoping hook — `.admin-home`/`.ent-admin-shell` alone are shared verbatim by
            // BankAdminLayout/HelpDeskLayout/BiometricLayout (confirmed: only BankAdminLayout adds its
            // own extra `.back-admin` class; HelpDesk/Biometric are otherwise identical to this file),
            // so a bare `.admin-home` override would leak into those 3 other portals — explicitly out
            // of scope this iteration. This mirrors the same safe-scoping pattern already used for
            // `.admin-login-refined` in the earlier Admin Login refinement.
            <div className="admin-home ent-admin-shell admin-shell-refined">
                <AdminHeader />
                <Layout className="ent-admin-body">
                    <AdminSidebar />
                    <Layout>
                        <Content
                            className={
                                this.state.showBorderMargin
                                    ? "container-fluid align-items-center align-items-stretch pl-0 "
                                    : "container-fluid align-items-center align-items-stretch "
                            }>
                            <div className="ent-admin-content">
                                {React.cloneElement(this.props.children, { isPageLoaded: this.state.isAnalysisRunning })}
                                {isShowSpinner == true &&
                                    <Spin size="large" tip="Fetching page data is in process"><Alert
                                        message="Loading please wait..."
                                        description="Fetching page data, please wait....."
                                        type="warning"
                                    /></Spin>}
                            </div>
                        </Content>
                        <div className="ent-app-footer">
                            Copyright {previousYear}-{currentYear}. All Rights Reserved.
                        </div>
                    </Layout>
                </Layout>
            </div>
        );
    }
}

export default withRouter(AdminLayout);
